<h1 class="heading">
  <a [routerLink]="'/'" class="heading__link">
    <span class="logo" [innerHtml]="logoBase64"></span>
    <span class="title">{{ title }}</span>
  </a>
</h1>
<bp-header-nav [user]="user"></bp-header-nav>
